import SurveysSerializer from './base';

export default class Survey extends SurveysSerializer {}
